/** Persisted IDs for “dismiss suggestion” on crew cards (carousel + Find crew). */
export const CREW_SUGGESTION_DISMISSED_KEY = 'crew_suggestion_dismissed_uids';

export function loadDismissedSuggestionUids(): Set<string> {
  try {
    const raw = localStorage.getItem(CREW_SUGGESTION_DISMISSED_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x): x is string => typeof x === 'string'));
  } catch {
    return new Set();
  }
}

export function persistDismissedSuggestionUids(ids: Set<string>): void {
  try {
    localStorage.setItem(CREW_SUGGESTION_DISMISSED_KEY, JSON.stringify([...ids]));
  } catch {
    /* ignore */
  }
}
